module.exports = __webpack_public_path__ + "img/newLogo.b1be0848.png";